import { SyntheticEvent } from "react";

interface DateSelectorProps {
    selectedMonth?: string;
    yearsStartFrom: number;
    selectedYear?: string;
    handleChange(e: SyntheticEvent): void;
}

interface YearsOptionsComponentProps {
    yearsStartFrom: number;
}

interface MonthsOptionsComponentProps {
    selectedYear?: string;
}

const YearsOptionsComponent = ({ yearsStartFrom }: YearsOptionsComponentProps) => {
    const curYear = new Date().getFullYear();

    const years = [
        <option key="Select Year" label={"Select Year"} value={0}>
            Select Year
        </option>,
    ];

    for (let year = curYear; year >= yearsStartFrom; year--) {
        years.push(
            <option key={year} label={String(year)} value={year}>
                {String(year)}
            </option>,
        );
    }

    return <>{years}</>;
};

const MonthsOptionsComponent = ({ selectedYear }: MonthsOptionsComponentProps) => {
    const curYear = new Date().getFullYear();
    const curMonth = new Date().getMonth();

    const months = [
        "Select Month",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ]
        .slice(0, selectedYear === String(curYear) ? curMonth + 2 : undefined)
        .map((month, idx) => (
            <option key={month} label={month} value={idx}>
                {month}
            </option>
        ));

    return <>{months}</>;
};

export const CoastFeedDateSelector = ({
    selectedYear,
    selectedMonth,
    yearsStartFrom,
    handleChange,
}: DateSelectorProps) => (
    <>
        <div className="coast-feed-navigation-filter">
            {/* Using onBlur here makes react mad */}
            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
            <select name="year" onChange={handleChange} value={selectedYear}>
                <YearsOptionsComponent yearsStartFrom={yearsStartFrom} />
            </select>
        </div>

        {!!selectedYear ? (
            <div className="coast-feed-navigation-filter">
                {/* Using onBlur here makes react mad */}
                {/* eslint-disable-next-line jsx-a11y/no-onchange */}
                <select
                    name="month"
                    onChange={handleChange}
                    value={selectedMonth !== undefined ? selectedMonth : "Select Month"}
                >
                    <MonthsOptionsComponent selectedYear={selectedYear} />
                </select>
            </div>
        ) : null}
    </>
);
